import { BigNumber, ethers } from 'ethers';
import { formatUnits } from 'ethers/lib/utils';
import { Contracts } from 'types';
class Position {
  nftId: number;
  unixTimestampOpened: number;
  lifetimeInDays: number;
  expiration: number;
  collateral: string;
  lvUSDBorrowed: string;
  totalInterestEarned: string;
  vaultId: number;
  apy: number;
  originationFee?: string;
  rebaseFreeRate?: string;
  ousdTotalWithoutInterest?: string;
  ousdBorrowed?: number;
  constructor(
    nftId: number,
    unixTimestampOpened: number,
    lifetimeInDays: number,
    expiration: number,
    collateral: BigNumber,
    lvUSDBorrowed: BigNumber,
    totalInterestEarned: BigNumber,
    vaultID: number,
    originationFee?: BigNumber,
    rebaseFreeRate?: BigNumber,
    ousdTotalWithoutInterest?: BigNumber,
    ousdBorrowed?: number,
  ) {
    this.nftId = nftId;
    this.unixTimestampOpened = unixTimestampOpened;
    this.lifetimeInDays = lifetimeInDays;
    this.expiration = expiration;
    this.collateral = ethers.utils.formatUnits(collateral);
    this.totalInterestEarned = ethers.utils.formatUnits(totalInterestEarned);
    this.lvUSDBorrowed = ethers.utils.formatUnits(lvUSDBorrowed);
    this.vaultId = vaultID;
    this.apy = Number(
      ((parseFloat(this.totalInterestEarned) + parseFloat(this.collateral)) * 100) / parseFloat(this.collateral) -
        100.0,
    );
    this.originationFee = ethers.utils.formatUnits(originationFee);
    this.rebaseFreeRate = ethers.utils.formatUnits(rebaseFreeRate);
    this.ousdTotalWithoutInterest = ethers.utils.formatUnits(ousdTotalWithoutInterest);
    this.ousdBorrowed = ousdBorrowed;
  }
}

export const getOpenPositions = async (contracts: Contracts, userAddress: string) => {
  if (!userAddress || !contracts) return [];
  try {
    const positionArray: Position[] = [];
    const tokenIds = await contracts.positionToken.getTokenIDsArray(userAddress);
    for (let i = 0; i < tokenIds.length; i++) {
      const tokenId = Number(formatUnits(tokenIds[i], 0));
      const validPositionId = await contracts.positionToken.exists(tokenId);
      if (validPositionId) {
        const isPositionOwner = await contracts.positionToken.ownerOf(tokenId);
        if (isPositionOwner === userAddress) {
          const nftId = tokenId;

          const positionTimeOpened = formatUnits(await contracts.cdp.getPositionTimeOpened(nftId), 0),
            positionTimeToLive = formatUnits(await contracts.cdp.getPositionTimeToLive(nftId), 0),
            positionExpireTime = formatUnits(await contracts.cdp.getPositionExpireTime(nftId), 0);

          const unixTimestampOpened = Number(positionTimeOpened),
            lifetimeInDays = Number(positionTimeToLive),
            expiration = Number(positionExpireTime);

          const collateral = await contracts.cdp.getOUSDPrinciple(nftId);
          const ousdTotalWithoutInterest = await contracts.cdp.getOUSDTotalWithoutInterest(nftId);
          const ousdBorrowed =
            Number(ethers.utils.formatUnits(ousdTotalWithoutInterest)) - Number(ethers.utils.formatUnits(collateral));
          const totalInterestEarned = await contracts.cdp.getOUSDInterestEarned(nftId);
          const lvUSDBorrowed = await contracts.cdp.getLvUSDBorrowed(nftId);
          const originationFee = await contracts.parameterStore.calculateOriginationFee(lvUSDBorrowed);
          const rebaseFreeRate = await contracts.parameterStore.getRebaseFeeRate();
          const vaultId = 1;

          /// create position class and push it to array of positions
          // TODO: remove class creation, I don't think we need this, will do some research
          const position = new Position(
            nftId,
            unixTimestampOpened,
            lifetimeInDays,
            expiration,
            collateral,
            lvUSDBorrowed,
            totalInterestEarned,
            vaultId,
            originationFee,
            rebaseFreeRate,
            ousdTotalWithoutInterest,
            ousdBorrowed,
          );
          positionArray.push(position);
        }
      }
    }
    return positionArray;
  } catch (err) {
    console.log('getOpenPositions err:', err);
    throw err;
  }
};
